import React from 'react';

const flightInfoTerminal = (props) => (
    <span className={`u-fontSize13 u-textColorNormal u-fontWeightRegular u-flex ${props.align === 'right' ? 'u-textAlignRight' : 'u-textAlignLeft'}`}>{props.children}</span>
);

export default flightInfoTerminal;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoTerminal/FlightInfoTerminal.js